import InputMask from "react-input-mask";
import { TextField } from "@mui/material";

const onlyNumbers = (str) => str.replace(/[^0-9]/g, "");
const numbersAndLetters = (str) => str.replace(/[^a-zA-Z0-9]/g, "");

const MaskedInput = ({
  value,
  onChange,
  onInput,
  name,
  mask,
  id,
  label,
  required,
  InputProps,
  InputLabelProps,
  variant,
  disabled,
  error,
  margin,
  onBlur,
  onKeyPress,
  type,
  sx,
}) => {
  function handleChange(event) {
    if (!onChange) return;
    const mascaraAlfanumerica = typeof mask === "string" && mask.includes("*");
    let value = "";
    if (mascaraAlfanumerica) {
      value = numbersAndLetters(event.target.value).toUpperCase();
    } else if (type && type === "text") {
      value = numbersAndLetters(event.target.value);
    } else {
      value = onlyNumbers(event.target.value);
    }
    onChange({
      ...event,
      target: {
        ...event.target,
        name,
        value,
      },
    });
  }

  return (
    <InputMask
      name={name}
      mask={mask}
      value={value ?? undefined}
      disabled={disabled}
      onBlur={onBlur}
      onInput={onInput}
      onChange={(event) => handleChange(event)}
    >
      <TextField
        id={id}
        name={name}
        label={label}
        variant={variant || "outlined"}
        type="text"
        margin={margin || "normal"}
        required={required}
        InputProps={InputProps}
        InputLabelProps={InputLabelProps}
        onKeyPress={onKeyPress}
        fullWidth
        error={error}
        sx={sx}
      />
    </InputMask>
  );
};

export default MaskedInput;
